import React from 'react'
import { Heading, Link } from 'components'
import Img from 'gatsby-image'

const FooterPosts = ({ heading, posts = [] }) => {
  return (
    <div className="col-span-4">
      <Heading className="text-white text-xl">{heading}</Heading>

      <ul className="mt-4 space-y-4 text-gray-300">
        {posts.map(({ id, title, slug, featuredImage, author, categories }) => {
          return (
            <li key={id} className="flex align-top space-x-4">
              <div className="w-16 flex-none rounded-md overflow-hidden">
                <Link to={`/blog/${slug}`}>
                  <Img
                    fluid={featuredImage.node.localFile.childImageSharp.fluid}
                  />
                </Link>
              </div>
              <div>
                <Link
                  className=" text-gray-300 underline block font-semibold"
                  to={`/blog/${slug}`}
                >
                  {title}
                </Link>
                <div className="text-xs text-gray-500 mt-2">
                  Posted by{' '}
                  <Link className="text-gray-400">{author.node.name}</Link>{' '}
                  under{' '}
                  <Link className="text-gray-400">
                    {categories.nodes[0].name}
                  </Link>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FooterPosts
